import { Currency } from '../../resources/currency/domain/types/currency';

export const UserPreferredCurrency = {
    key: 'userPreferredCurrency',
    get(): Currency | null {
        try {
            return localStorage.getItem(this.key) as Currency | null;
        } catch {
            return null;
        }
    },
    set(currency: Currency): void {
        try {
            localStorage.setItem(this.key, currency);
        } catch {
            // nothing to do
        }
    },
};
